import React, { ReactNode } from 'react';
import { Tree } from 'antd';
import { TreeNode } from 'antd/lib/tree-select';

export type TreeNodeProps = typeof TreeNode & {
  children?: ReactNode;
};

const ProTreeNode: React.FC<TreeNodeProps> = (props) => {
  const { children, ...resProps } = props;

  return <Tree.TreeNode {...resProps}>{children}</Tree.TreeNode>;
};

export default ProTreeNode;
